import React, { useState, useContext } from "react";
import "./Metrics.scss";
import { Tabs, Row, Col, Card, Modal, Button, Carousel, Select, Collapse, Layout } from "antd";
import { useEffect } from "react";
const { Content } = Layout;

const metric_data = [
    {
        'title': '8x',
        'desc': 'Increase in listing views',
    },
    {
        'title': '2x',
        'desc': 'Higher conversion rate',
    },
    {
        'title': '9%',
        'desc': 'Increase in sales',
    },
    {
        'title': '40%',
        'desc': 'Lower return rate',
    },

]

const Metrics = () => {

    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
}

const WebVersion = () => {
    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid justify-in-center metrics-win-bg">
                {metric_data.map((metric, index) => (
                    <Col className={`metric-col ${index == (metric_data.length - 1) ? `` : `border-r`}`}>
                        <div>
                            <h1 className="manrope f-38 white lh-46 w-500 mb-8">{metric.title}</h1>
                            <p className="manrope f-16 lh-24 white w-700 mb-0">{metric.desc}</p>
                        </div>
                    </Col>
                ))}
            </Row>
        </Content>
    );
}


const MobileVersion = () => {
    return (
        <Content className="d-lg-none">
            <Row className="container-fluid justify-space-between metrics-win-bg">
                {metric_data.map((metric, index) => (
                    <Col span={24} className={`metric-col ${index == (metric_data.length - 1) ? `` : `border-r`}`}>
                        <h1 className="manrope f-38 white lh-46 w-500 mb-8">{metric.title}</h1>
                        <p className="manrope f-16 lh-24 white w-700 mb-0">{metric.desc}</p>
                    </Col>
                ))}
            </Row>
        </Content>
    );
}

export default Metrics;
